const hRange = [0, 360] // All color palette
const sRange = [30, 70] // Not too bright and not too dark
const lRange = [30, 70]

const getHashOfString = (str: string) => {
    let hash = 0
    for (let i = 0; i < str.length; i++) {
        hash = str.charCodeAt(i) + ((hash << 5) - hash)
    }
    hash = Math.abs(hash)
    return hash
}

const normalizeHash = (hash: number, min: number, max: number) => Math.floor((hash % (max - min)) + min)

const generateHSL = (str: string): number[] => {
    const hash = getHashOfString(str)

    const h = normalizeHash(hash, hRange[0], hRange[1])
    const s = normalizeHash(hash, sRange[0], sRange[1])
    const l = normalizeHash(hash, lRange[0], lRange[1])

    return [h, s, l]
}

const HSLtoString = (hsl: number[]) => `hsl(${hsl[0]}, ${hsl[1]}%, ${hsl[2]}%)`

export const getHSLColor = (str: string) => HSLtoString(generateHSL(str))
